<!--
 * @Author: zhouhx
 * @Date: 2024-02-26 14:15:12
 * @LastEditors: zhouhx
 * @LastEditTime: 2024-02-28 14:21:04
 * @Description: 列表-头部检索
-->
<template>
  <div :class="{ topHeader: breadBtn, autoHeader: !breadBtn }" class="common-header">
    <div class="left" @click="clickLeft()" v-if="breadBtn">
      <img src="@/assets/ic_24_menu@3x.png" />
    </div>
    <div class="right">
      <van-search v-model="keyData" show-action label="" placeholder="请输入搜索关键词" @search="onSearch">
        <template #action>
          <img v-if="datePicker" @click="showDate" src="@/assets/ic_24_calendar@3x.png" />
        </template>
      </van-search>
    </div>

    <div class="modaldiv" v-if="datePicker">
      <div class="cover" v-if="date.coverStatus"></div>
      <van-radio-group v-if="date.coverStatus" class="checkDateData" v-model="date.checked">
        <van-cell-group inset>
          <van-cell :title="d.title" clickable @click="selected(d)" v-for="(d, i) in date.dateList" :key="i">
            <template #right-icon>
              <van-radio :name="d.value" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>

    </div>
  </div>
</template>
<script>
export default {
  components: {
  },
  props: {
    breadBtn: {},
    datePicker: {}
  },
  data () {
    return {
      keyData: '',
      date: {
        checked: '0',
        dateList: [
          {
            title: '全时间段',
            value: '0'
          },
          {
            title: '近三天',
            value: '3'
          },
          {
            title: '近一周',
            value: '7'
          },
          {
            title: '近一个月',
            value: '30'
          },
          {
            title: '近三个月',
            value: '90'
          },
          {
            title: '近六个月',
            value: '180'
          }
        ],
        coverStatus: false
      }
    }
  },
  created () { },
  methods: {
    // 点击左侧图标弹出侧边栏
    clickLeft () {
      this.$emit('receiveData', 'leftslide')
    },
    onSearch () {
      this.$emit('receiveData', 'key', this.keyData)
    },
    showDate () {
      this.date.coverStatus = !this.date.coverStatus
    },
    selected (data) {
      console.log('===', data)
      this.date.checked = data.value
      this.date.coverStatus = false
      this.$emit('receiveData', 'date', this.date.checked)
    }
  }
}
</script>
<style lang="scss" scoped>
.topHeader {
  position: fixed;
  top: 0;
  z-index: 9;

  .right {
    padding: 0 0 0 35px;
  }
}
.autoHeader ::v-deep .van-search__action {
  width: 0 !important;
}

.common-header {
  height: 52px;
  width: 100%;
  background: $white;

  .left {
    position: absolute;
    top: 50%;
    left: 18px;
    transform: translateY(-50%);

    img {
      width: 24px;
      height: 24px;
    }
  }




  .modaldiv {
    .cover {
      width: 100%;
      height: 100vh;
      background: #000;
      opacity: .2;
    }

    .checkDateData {
      position: absolute;
      top: 52px;
      width: 100%;
      z-index: 10;
      transition: all 1s;
    }
  }
}
</style>
